import React, { useState, useEffect } from 'react';

import './styles.css';

import checkDeviceType from '../../../checkDeviceType';

import convertAge from '../../../functions/convertAge';
import compare from '../../../functions/compare';

import studentsServices from '../../../services/academy/studentsServices';
import reportServices from '../../../services/reportServices';

import MainView from '../../../components/MainView';
import NavHistory from '../../../components/NavHistory';
import SearchBar from '../../../components/SearchBar';
import { Link, useParams } from 'react-router-dom';
import { useLocation } from 'react-router';
import ListOptions from '../../../components/ListOptions';
import ActivityIndicator from '../../../components/ActivityIndicator';
import StudentsCard from './StudentsCard';
import PopupStudentsReports from './PopupStudentsReports';
import { FaUserPlus, FaPrint } from 'react-icons/fa';
import AdminCard from '../../../components/AdminCard';
import PopupNewEmail from './PopupNewEmail';

export default function Students(props) {
    const { search } = useLocation();
    const [deviceType, setDeviceType] = useState(checkDeviceType());
    const [searchText, setSearchText] = useState('');
    const [filterOption, setFilterOption] = useState(0);
    const [activeOption, setActiveOption] = useState(0);
    const [orderOptionInfos, setOrderOptionInfos] = useState([]);
    const [studentsList, setStudentsList] = useState([]);
    const [searchedStudentsList, setSearchedStudentsList] = useState([]);
    const [filteredStudentsList, setFilteredStudentsList] = useState([]);
    const [countStudents, setCountStudents] = useState(0);
    const [popupStudentsReportsVisible, setPopupStudentsReportsVisible] = useState(false);
    const [fetching, setFetching] = useState(true);
    const [isAdmin, setIsAdmin] = useState(false);

    const[selectToEmail, setSelectToEmail] = useState(false);
    const[popupEmail, setPopupEmail] = useState(false);
    const[studentsSelectedToEmail, setStudentsSelectedToEmail] = useState({});
    const [title, setTitle] = useState("");
    const [content, setContent] = useState("");


    const { id } = useParams();

    function verifyIsAdmin() {
        setIsAdmin(props.history.location.pathname.includes("admin"));

    }

    useEffect(() => {
        const querys = search.slice(1).split('&');

        if (querys.indexOf('inadimplentes') !== -1 && props.coachMode !== true)
            setFilterOption(2);

        if (querys.indexOf('ativos') !== -1)
            setActiveOption(1);

        window.addEventListener('resize', () => {
            setDeviceType(checkDeviceType())
        });

        verifyIsAdmin();

        readStudents();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (studentsList.length > 1)
            searchStudent();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [studentsList, orderOptionInfos, filterOption, activeOption]);

    async function readStudents() {
        const response = await studentsServices.getStudents();
        if (response.status === 200) {
            setStudentsList(response.data);
        } else
            alert("Erro ao ler alunos, tente novamente!");

        setFetching(false);
    };

    function filterStudents(option = filterOption, actives = activeOption, array = searchedStudentsList) {
        let auxList;

        switch (option) {
            case 1:
                auxList = array.filter((item) => item.inadimplente === false);
                break;
            case 2:
                auxList = array.filter((item) => item.inadimplente === true);
                break;
            default:
                auxList = array;
        }

        // eslint-disable-next-line default-case
        switch (actives) {
            case 1:
                auxList = auxList.filter((item) => item.user.ativo === true);
                break;
            case 2:
                auxList = auxList.filter((item) => item.user.ativo === false);
                break;
        }

        if (countStudents !== auxList.length)
            setCountStudents(auxList.length);

        setFilteredStudentsList(auxList);
    }

    function orderStudents(option, orderOption, array = searchedStudentsList, setArray = setSearchedStudentsList) {
        let auxList = array.slice();
        switch (option) {
            case 1: // Ordena pela idade
                auxList.sort((a, b) => compare(`${a.nome} ${a.sobrenome}`, `${b.nome} ${b.sobrenome}`));
                auxList.sort((a, b) => compare(convertAge(a.data_nascimento), convertAge(b.data_nascimento), orderOption));
                break;
            case 2: // Ordena pela turma
                auxList.sort((a, b) => compare(`${a.nome} ${a.sobrenome}`, `${b.nome} ${b.sobrenome}`));
                auxList.sort((a, b) => compare(a.turma ? a.turma.nome : null, b.turma ? b.turma.nome : null, orderOption));
                break;
            default: // Ordena pelo nome
                auxList.sort((a, b) => compare(`${a.nome} ${a.sobrenome}`, `${b.nome} ${b.sobrenome}`, orderOption));
        }
        setArray(auxList);
        filterStudents(filterOption, activeOption, auxList);
    }

    function searchStudent(searchName = searchText, array = studentsList) {
        let auxList = array.filter((item) => `${item.nome} ${item.sobrenome}`.toLowerCase().includes(searchName.toLowerCase()) || item.id.toString() === searchName);
        orderStudents(orderOptionInfos[0], orderOptionInfos[1], auxList);
    }

    function onDisableStudent(index) {
        const indexOf = studentsList.indexOf(filteredStudentsList[index]);
        setStudentsList(originalArray => {
            let temp = [...originalArray];
            temp[indexOf].user.ativo = false;
            return temp;
        });
    }

    function onActivateStudent(index) {
        const indexOf = studentsList.indexOf(filteredStudentsList[index]);
        setStudentsList(originalArray => {
            let temp = [...originalArray];
            temp[indexOf].user.ativo = true;
            return temp;
        });
    }

    async function disableStudent(index, id, nome) {
        // eslint-disable-next-line no-restricted-globals
        if (confirm(`Deseja desativar o aluno ${nome}?`)) {
            const response = await studentsServices.disableStudent(id);
            if (response.status === 200) {
                onDisableStudent(index);
                console.log(`Aluno ${nome} desativado!`);
            } else
                alert("Erro ao apagar aluno, tente novamente!");
        }
    }

    async function activateStudent(index, id, nome) {
        // eslint-disable-next-line no-restricted-globals
        if (confirm(`Deseja ativar o aluno ${nome}?`)) {
            const response = await studentsServices.activateStudent(id);
            if (response.status === 200) {
                onActivateStudent(index);
                console.log(`Aluno ${nome} ativado!`);
            } else
                alert("Erro ao ativar aluno, tente novamente!");
        }
    }

    function selectPaymentStatus(status, scholarshipStatus) {
        if (scholarshipStatus === true) return "Bolsa";
        
        switch (status) {
            case false:
                return "Pago"
            case true:
                return "Não pago"
            default:
                return "-"
        }
    }

    async function generateReport(fields = null, fileName) {
        console.log(fields);
        try {
            await reportServices.generateReportStudents(filteredStudentsList, "RELATÓRIO DE ALUNOS DA ACADEMIA", fields, fileName);
            return true;
        } catch (err) {
            alert(err.message);
            return false;
        }
    }

    async function onSendEmail() {
            setSelectToEmail(false);
            setStudentsSelectedToEmail({});
            setPopupEmail(false);
    }


    return (
        <MainView currentPage={isAdmin ? 'academies' : 'students'} adminMenu={isAdmin} coachMenu={props.coachMode}>
            <NavHistory navPages={['Alunos']} />

            <div className='students-page-options'>
                <SearchBar
                    placeholder={deviceType === 'phone' ? "Nome ou ID do aluno" : "Digite o nome ou o ID do aluno"}
                    onChange={(event) => {
                        setSearchText(event.target.value);
                        if (event.target.value === "")
                            orderStudents(orderOptionInfos[0], orderOptionInfos[1], studentsList);
                    }}
                    value={searchText}
                    onClick={() => searchStudent()}
                />

                {
                    props.coachMode ?
                        [] :
                        <div className='students-page-options-buttons'>
                            <button className='button' onClick={() => {
                                if(selectToEmail)
                                    setStudentsSelectedToEmail({})
                                setSelectToEmail(!selectToEmail)
                            }}>
                                {
                                    !selectToEmail ?
                                        "Enviar Email"
                                    :
                                        "Cancelar Envio"
                                }
                            </button>
                            {
                                selectToEmail ?
                                <>
                                    <button onClick={() => setPopupEmail(true)}>
                                        Enviar
                                    </button>
                                    <PopupNewEmail
                                        visibility={popupEmail}
                                        setVisibility={setPopupEmail}
                                        ids={studentsSelectedToEmail}
                                        onSend={onSendEmail}
                                    />
                                </>
                                :
                                <>
                                    <Link to={isAdmin ? `/admin/academias/${id}/alunos/cadastro` : '/academia/alunos/cadastro'} className='button new-student' title="Novo aluno">
                                        Novo aluno<FaUserPlus />
                                    </Link>

                                    <button title="Gerar relatório" onClick={() => setPopupStudentsReportsVisible(true)}><FaPrint /></button>
                                </>
                            }
                            <PopupStudentsReports
                                visibility={popupStudentsReportsVisible}
                                setVisibility={setPopupStudentsReportsVisible}
                                generateReport={generateReport}
                            />
                        </div>
                }
            </div>


            <div className='students-page-list-infos'>
                <span>Exibindo {countStudents} {countStudents === 1 ? "aluno" : "alunos"}</span>
                <div className='students-page-list-options'>
                    <ListOptions
                        title='Status'
                        options={["Todos", "Ativos", "Inativos"]}
                        setOptionInfos={setActiveOption}
                        optionInfos={activeOption}
                    />
                    {
                        props.coachMode || isAdmin ?
                            [] :
                            <ListOptions
                                title='Pagamento'
                                options={["Todos", "Pagos", "Não pagos"]}
                                setOptionInfos={setFilterOption}
                                optionInfos={filterOption}
                            />
                    }
                    <ListOptions
                        title='Ordenar'
                        options={["Nome", "Idade", "Turma"]}
                        isToOrder
                        setOptionInfos={setOrderOptionInfos}
                    />
                </div>
            </div>

            {
                !fetching ?
                    <ul className='students-page-list'>
                        {
                            searchedStudentsList && searchedStudentsList.length !== 0 ?
                                filteredStudentsList.map((item, index) => {
                                    return isAdmin ?
                                        <AdminCard
                                            obj={item}
                                            foto={item.foto}
                                            nome={item.nome + " " + item.sobrenome}
                                            key={index}
                                            onDisable={() => disableStudent(index, item.id, item.nome)}
                                            onActivate={() => activateStudent(index, item.id, item.nome)}
                                            little={deviceType === 'phone'}
                                            active={item.user.ativo}
                                            linkInfo={`/admin/academias/${id}/alunos/${item.id}`}
                                            onEditPassword={studentsServices.patchStudentPassword}
                                        />
                                        :

                                        <StudentsCard
                                            key={item.id}
                                            id={item.id}
                                            src={item.foto}
                                            name={`${item.nome} ${item.sobrenome}`}
                                            active={item.user.ativo}
                                            age={convertAge(item.data_nascimento)}
                                            class={item.turma ? item.turma.nome : "Sem turma"}
                                            documents={item.documentos}
                                            scholarshipDueDate={item.bolsa && item.data_fim_matricula ? item.data_fim_matricula.split('-').reverse().join('/') : null}
                                            dueDate={item.pagamento ? item.pagamento.split('-').reverse().join('/') : null}
                                            status={selectPaymentStatus(item.inadimplente, item.bolsa)}
                                            little={deviceType === 'phone' ? true : false}
                                            medium={deviceType === 'tablet' ? true : false}
                                            onDisable={() => disableStudent(index, item.id, item.nome)}
                                            onActivate={() => activateStudent(index, item.id, item.nome)}
                                            coachMode={props.coachMode}

                                            isAdmin={isAdmin}
                                            academyId={id}

                                            selectToEmail={selectToEmail}
                                            setStudentsSelectedToEmail={setStudentsSelectedToEmail}
                                            studentsSelectedToEmail={studentsSelectedToEmail}

                                        />
                                }

                                )
                                : []
                        }
                    </ul>
                    : <ActivityIndicator />
            }
        </MainView>
    )
}